import React, { ChangeEvent } from 'react';
import Signature from '../../../../signature/signature';
import UploadStamp from '../../common/UploadStamp';
import { Grid, TextField } from '@mui/material';
import Customdatepicker from '../../../../customdatepicker/customdatepicker';
import { CommercialSignatureInterface } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import CustomTextField from '../../../../CustomTextInput';

const SignatureFields = ({
    payload,
    setPartnerId,
    setShowAddPartner,
    updateField,
    errors,
    setSignatureUrlBase64,
    signatureUrlBase64
}: CommercialSignatureInterface) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2 h-full relative lg:hidden'>
                    <div
                        className='absolute lg:right-8 lg:top-6 top-10 right-4 cursor-pointer text-appcolorprimary z-50'
                        onClick={
                            payload?.bankDetails
                                ? () => {
                                      setShowAddPartner(true);
                                      setPartnerId(payload?.exporterId);
                                  }
                                : undefined
                        }
                    >
                        Edit partner
                    </div>

                    <CustomTextField
                        multiline
                        rows={3.8}
                        height={156}
                        disabled
                        id='commercialinvoice-bankDetails'
                        value={payload?.bankDetails || ''}
                        label='Banks Details'
                        name='bankDetails'
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            updateField('bankDetails', e.target.value);
                        }}
                    />

                    <div className='mt-2 lg:mt-0'>
                        <CustomTextField
                            multiline
                            rows={3.8}
                            height={156}
                            value={payload?.additionalInformation || ''}
                            id='commercialinvoice-additionalInformation'
                            label='Additional Information'
                            name='additionalInformation'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField(
                                    'additionalInformation',
                                    e.target.value
                                );
                            }}
                        />
                    </div>
                </div>

                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2 h-full relative hidden lg:block'>
                    <div
                        className='absolute lg:right-8 lg:top-6 top-10 right-4 cursor-pointer text-appcolorprimary z-50'
                        onClick={
                            payload?.bankDetails
                                ? () => {
                                      setShowAddPartner(true);
                                      setPartnerId(payload?.exporterId);
                                  }
                                : undefined
                        }
                    >
                        Edit partner
                    </div>
                    <div className='mt-4'>
                        <TextField
                            multiline
                            rows={3.8}
                            disabled
                            fullWidth
                            id='commercialinvoice-bankDetails'
                            value={payload?.bankDetails || ''}
                            label='Banks Details'
                            name='bankDetails'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField('bankDetails', e.target.value);
                            }}
                        />
                    </div>
                    <div className='mt-8'>
                        <TextField
                            multiline
                            rows={3.8}
                            fullWidth
                            value={payload?.additionalInformation || ''}
                            id='commercialinvoice-additionalInformation'
                            label='Additional Information'
                            name='additionalInformation'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField(
                                    'additionalInformation',
                                    e.target.value
                                );
                            }}
                        />
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2 h-full'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4'>
                                <CustomTextField
                                    error={errors?.placeOfIssue.length > 0}
                                    helperText={
                                        errors?.placeOfIssue.length > 0
                                            ? errors?.placeOfIssue
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-placeOfIssue'
                                    label='Place of Issue'
                                    name='placeOfIssue'
                                    value={payload?.placeOfIssue || ''}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'placeOfIssue',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 mt-2'>
                                <Customdatepicker
                                    value={payload?.dueDate || null}
                                    id='proformainvoice-date'
                                    label='Due Date'
                                    name='dueDate'
                                    updateField={updateField}
                                    error={errors?.dueDate.length > 0}
                                    helperText={
                                        errors?.dueDate.length > 0
                                            ? errors?.dueDate
                                            : undefined
                                    }
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                            <div className='lg:mt-4  mt-2'>
                                <CustomTextField
                                    error={errors?.signatoryCompany.length > 0}
                                    helperText={
                                        errors?.signatoryCompany.length > 0
                                            ? errors?.signatoryCompany
                                            : undefined
                                    }
                                    required
                                    value={payload?.signatoryCompany || ''}
                                    id='commercialinvoice-signatoryCompany'
                                    label='Signatory Company'
                                    name='signatoryCompany'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'signatoryCompany',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                            <div className='lg:mt-4  mt-2'>
                                <CustomTextField
                                    error={
                                        errors?.nameOfAuthorisedSignatory
                                            .length > 0
                                    }
                                    helperText={
                                        errors?.nameOfAuthorisedSignatory
                                            .length > 0
                                            ? errors?.nameOfAuthorisedSignatory
                                            : undefined
                                    }
                                    required
                                    value={
                                        payload?.nameOfAuthorisedSignatory || ''
                                    }
                                    id='commercialinvoice-nameOfAuthorisedSignatory'
                                    label='Name of Authorized Signature'
                                    name='nameOfAuthorisedSignatory'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'nameOfAuthorisedSignatory',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                            <div className='flex gap-2 items-center mt-3'>
                                <UploadStamp
                                    {...{
                                        payload,
                                        updateField
                                    }}
                                    name="Exporter's Stamp Image"
                                />
                            </div>
                            <div className='w-full  mt-2 lg:mt-0'>
                                <Signature
                                    name='signatureUrl'
                                    updateField={updateField}
                                    setSignatureUrlBase64={
                                        setSignatureUrlBase64
                                    }
                                    signatureUrlBase64={signatureUrlBase64}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
};

export default SignatureFields;
